// react
import { useRef, useEffect } from "react";
// components
import Ripple from "../ui/spinners/ripple/Ripple";
// icons
import { IoIosCloseCircleOutline } from "react-icons/io";
// css
import classNames from "classnames";

const AutoComplete = (props) => {
  // props
  const {
    options,
    loading,
    label,
    inputPlaceHolder,
    inputValue,
    onInputChange,
    onInputClear,
    hideOptions,
    showOptions,
    isOptionsVisible,
    showInputOnly,
    disabled,
    required,
  } = props;
  // refs
  const dropDownContainerRef = useRef(null);

  // click away
  useEffect(() => {
    const clickedAwayHandler = (event) => {
      const { current: dropDownWrapper } = dropDownContainerRef;
      if (dropDownWrapper && !dropDownWrapper.contains(event.target)) {
        hideOptions();
      }
    };
    document.addEventListener("mousedown", clickedAwayHandler);

    return () => {
      document.removeEventListener("mousedown", clickedAwayHandler);
    };
  }, [hideOptions]);

  let content = null;
  if (showInputOnly) {
    content = (
      <>
        <label className="block" htmlFor="autoCompleteInput">
          {label}
        </label>
        <div className="relative">
          <input
            id="autoCompleteInput"
            className="p-2 border border-#DFDFDF rounded w-full focus:border-dark-blue rounded"
            placeholder={inputPlaceHolder}
            value={inputValue}
            autoComplete="off"
            onChange={(e) => onInputChange(e.target.value)}
            onClick={() => showOptions()}
            required={required}
          />
          {inputValue && (
            <IoIosCloseCircleOutline
              size={20}
              className="text-slate-400 bg-white hover:text-slate-800 absolute z-5 left-2 top-1/2 -translate-y-1/2 cursor-pointer"
              onClick={() => onInputClear()}
            />
          )}
        </div>
      </>
    );
  }
  if (loading) {
    content = <Ripple className="border-dark-blue" />;
  } else if (options) {
    content = (
      <div className="relative" ref={dropDownContainerRef}>
        <label className="block" htmlFor={label}>
          {label}
        </label>
        <div className="relative">
          <input
            id={label}
            className="p-2 border border-#DFDFDF rounded w-full focus:border-dark-blue rounded"
            placeholder={inputPlaceHolder}
            autoComplete="off"
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
            onClick={() => showOptions()}
            disabled={disabled}
            required={required}
          />
          {inputValue && !disabled && (
            <IoIosCloseCircleOutline
              size={20}
              className="text-slate-400 bg-white hover:text-slate-800 absolute z-5 left-2 top-1/2 -translate-y-1/2 cursor-pointer"
              onClick={() => onInputClear()}
            />
          )}
        </div>
        <div
          className={classNames(
            "w-full absolute z-20 top-15 box-shadow scrollbar-hide shadow-2xl transition-all",
            { "h-0 max-h-0 overflow-y-hidden": !isOptionsVisible },
            {
              "h-auto max-h-60 overflow-y-auto border border-t-0":
                isOptionsVisible,
            }
          )}
        >
          {options}
        </div>
      </div>
    );
  }
  return content;
};

export default AutoComplete;
